document.addEventListener("DOMContentLoaded", () => {
  let tl = gsap.timeline({ repeat: -1 });

  // group 1: first two animations repeated 3 times
  for (let i = 0; i < 3; i++) {
    tl.to(".img-brush", {
      y: "-40%",
      x: "10%",
      yoyo: true,
      duration: 0.4,
      ease: "power3.out",
      onStart: () => shadowAnim.play(),
    }).to(".img-brush", {
      y: "20%",
      x: "0%",
      yoyo: true,
      duration: 0.4,
      ease: "power3.out",
    });
  }

  // group 2: final animation (once)
  tl.to(".img-brush", {
    rotation: 40,
    y: "70%",
    x: "50%",
    yoyo: true,
    duration: 1,
    ease: "power2.out",
    repeat: 1,
    onStart: () => shadowAnim.reverse(),
  });

  let shadowAnim = gsap.fromTo(
    ".img-shadow",
    { scaleY: 1, scaleX: 1.02 },
    {
      scaleY: 1.05,
      scaleX: 1,
      duration: 2,
      ease: "power1.out",
      paused: true,
    }
  );

  gsap.set(".img-shadow", {
    transformPerspective: 200,
    transformStyle: "preserve-3d",
  });

  gsap.fromTo(
    ".img-foam",
    { x: 0, y: 0, yoyo: true, repeat: -1, duration: 2, ease: "power1.out" },
    { x: 10, y: 20, yoyo: true, repeat: -1, duration: 2, ease: "power1.out" }
  );
});
